const projects = [
  {
    id: 1,
    slug: 'spark-ai',
    name: 'Spark AI',
    description: 'Giving AI a voice through motion — animating the moments between input and response so users always know what\'s happening and what comes next.',
    tags: 'Motion Systems · UX Animation · Interaction Design',
  },
  {
    id: 2,
    slug: 'event-calendar',
    name: 'Event Calendar',
    description: 'Full product and interaction design for a scheduling interface — from Figma layouts to a Rive prototype with state machines that make complex calendar logic feel effortless.',
    tags: 'Product Design · Interaction Design · Motion Design',
  },
  {
    id: 3,
    slug: 'content-journeys',
    name: 'Content Journeys',
    description: 'An interactive learning experience where motion does the teaching — guiding users through health content with feedback, progression, and a matchmaker interaction built in Rive.',
    tags: 'Interaction Design · UX Animation · Motion Design',
  },
  {
    id: 4,
    slug: 'emoji-reactions',
    name: 'Emoji Reactions',
    description: 'A reaction system where every tap feels right — selection states, interaction logic, and motion feedback designed to be scalable across a full product.',
    tags: 'Interaction Design · Motion Systems · Motion Design',
  },
  {
    id: 5,
    slug: 'challenges',
    name: 'Challenges',
    description: 'An avatar system for a tournament health challenge — 40 animated activities and character customization logic built and animated entirely in Rive.',
    tags: 'Motion Systems · Interaction Design · Character Animation',
  },
  {
    id: 6,
    slug: 'ui-animations',
    name: 'UI Animations',
    description: 'A collection of seven UI animations created for WebMD Health Services across multiple products and features — from onboarding flows to skeleton loaders to win states.',
    tags: 'Motion Design · UI Animation · Interaction Design',
  },
  {
    id: 8,
    slug: 'writing-revolution',
    name: 'The Writing Revolution',
    description: 'Two 2D explainer videos brought to life through close collaboration with a creative director — from style frames to final animation, I directed the full motion.',
    tags: 'Motion Design · 2D Animation · Explainer',
  },
  {
    id: 9,
    slug: 'vu-talent',
    name: 'VU Talent',
    description: 'Web animations for a talent company\'s marketing site — built from provided designs and storyboards through Portland studio Hank Makes.',
    tags: 'Motion Design · Web Animation · 2D',
  },
  {
    id: 10,
    slug: 'vital-elements',
    name: 'Vital Elements',
    description: 'Logo animation for Good and Well Co — taking a static mark and giving it a life that feels true to the brand.',
    tags: 'Motion Design · Logo Animation · Brand',
  },
];

export default projects;
